import { ProductDataVariant } from '../../../services/product/product-data'
import {
  CURRENT_PRICE_PLACEHOLDER,
  OLD_PRICE_PLACEHOLDER
} from '../../../utils/constants'
import { formatPrice, FormatPriceOptions } from '../../../utils/format-price'

export const getPriceData = (
  priceData: ProductDataVariant['price'],
  allowSubscriptionPrice: boolean = false
) => {
  const originalPriceValue = priceData?.grossPrice
  const subscriptionPriceValue = priceData?.subscriptionPrice
  const discountPriceValue = priceData?.priceDiscount?.value

  const hasSubscriptionPrice =
    allowSubscriptionPrice &&
    typeof subscriptionPriceValue === 'number' &&
    subscriptionPriceValue > 0

  const hasDiscount =
    originalPriceValue &&
    discountPriceValue &&
    discountPriceValue < originalPriceValue

  let currentPrice = originalPriceValue

  if (hasSubscriptionPrice) {
    currentPrice = subscriptionPriceValue
  } else if (hasDiscount) {
    currentPrice = discountPriceValue
  }

  return {
    originalPriceValue,
    subscriptionPriceValue,
    discountPriceValue,
    currentPrice,
    hasDiscount,
    hasSubscriptionPrice
  }
}

export const getPriceInfo = ({
  data,
  pageLocale,
  showOldPrices = true,
  currentPriceLabelProp,
  oldPriceLabelProp,
  formatPriceOptions,
  allowSubscriptionPrice = false
}: {
  data: ProductDataVariant['price']
  pageLocale: string
  showOldPrices?: boolean
  currentPriceLabelProp?: string
  oldPriceLabelProp?: string
  formatPriceOptions?: FormatPriceOptions
  allowSubscriptionPrice?: boolean
}) => {
  const hasValue = !!data?.grossPrice
  const { originalPriceValue, currentPrice, hasDiscount } = getPriceData(
    data,
    allowSubscriptionPrice
  )

  const formattedCurrentPrice = formatPrice({
    value: Number(currentPrice),
    currency: data?.priceCurrency,
    locale: pageLocale,
    options: formatPriceOptions
  })
  const formattedOriginalPrice = formatPrice({
    value: Number(originalPriceValue),
    currency: data?.priceCurrency,
    locale: pageLocale,
    options: formatPriceOptions
  })

  const currentPriceMessage = formattedCurrentPrice
    ? (currentPriceLabelProp?.replace(
        CURRENT_PRICE_PLACEHOLDER,
        formattedCurrentPrice
      ) ?? formattedCurrentPrice)
    : null

  const originalPriceMessage = formattedOriginalPrice
    ? (oldPriceLabelProp?.replace(
        OLD_PRICE_PLACEHOLDER,
        formattedOriginalPrice
      ) ?? formattedOriginalPrice)
    : null

  return hasValue
    ? {
        currentPrice: currentPriceMessage,
        currentPriceTextProps: {
          content: currentPriceMessage
        },
        ...(showOldPrices &&
          hasDiscount && {
            originalPrice: originalPriceMessage,
            originalPriceTextProps: {
              content: originalPriceMessage
            }
          })
      }
    : undefined
}

export const getPriceInfoMiniCart = (
  formattedTotalWithoutDiscounts: string = '',
  formattedTotalPrice: string = '',
  showOldPrices: boolean = true
) => {
  const hasDiscount = formattedTotalWithoutDiscounts !== formattedTotalPrice
  const formattedCurrentPrice = hasDiscount
    ? formattedTotalPrice
    : formattedTotalWithoutDiscounts
  const formattedOriginalPrice = formattedTotalWithoutDiscounts

  return {
    currentPriceTextProps: {
      content: formattedCurrentPrice
    },
    ...(showOldPrices &&
      hasDiscount && {
        originalPriceTextProps: {
          content: formattedOriginalPrice
        }
      })
  }
}
